import { maxLength, required } from "@vuelidate/validators";

export default class Equipament {
  constructor() {
    this.id = null;
    this.name = null;
    this.rp = null;
    this.serial = null;
    this.status = true;
  }
  validations() {

    return {
      name: {
        required,
        maxLength: maxLength(50)
      },
      // rp: {
      //   required,
      //   maxLength: maxLength(50)
      // },
      // serial: {
      //   required,
      //   maxLength: maxLength(50)
      // },
      //
      status: {
        required,
      },
    }

  }
}
